__turbopack_context__.v({
  "className": "maxi_276b3216-module__OFy0YG__className",
  "variable": "maxi_276b3216-module__OFy0YG__variable",
});
